import styled from 'styled-components';

export const DropDownContainer = styled.div`
    width: 100%;
    padding: 10px 10px 10px 15px;
`;

export const EmployeeName = styled.div`
    font-size: 14px;
    color: #140F4B;
    font-family: 'AvenirNextWorld Regular';
`;

export const EmployeeRole = styled.div`
    font-size: 12px;
    color: #140F4B;
    font-family: 'AvenirNextWorld Regular';
    opacity: 0.7;
`;

